import * as React from "react"
import type { SVGProps } from "react"
const SvgPuzzle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.8 21.43H5q-.82 0-1.41-.59A2 2 0 0 1 3 19.43v-3.8q1.2 0 2.1-.76.9-.77.9-1.94t-.9-1.94a3.2 3.2 0 0 0-2.1-.76v-3.8q0-.83.59-1.41A2 2 0 0 1 5 4.43h4q0-1.06.73-1.77.72-.73 1.77-.73c1.05 0 1.3.24 1.78.72q.72.73.72 1.78h4q.83 0 1.41.59.6.59.59 1.41v4q1.05 0 1.78.73.72.72.72 1.77c0 1.05-.24 1.3-.72 1.78q-.73.72-1.78.72v4q0 .82-.59 1.41a2 2 0 0 1-1.41.59h-3.8q0-1.25-.79-2.12-.78-.88-1.91-.88c-1.13 0-1.39.3-1.91.88q-.8.87-.79 2.12m-3.8-2h2.13a4 4 0 0 1 1.92-2.33q1.32-.67 2.45-.67t2.45.67a4 4 0 0 1 1.93 2.33H18v-6h2a.5.5 0 0 0 .35-.15.5.5 0 0 0 0-.7.5.5 0 0 0-.35-.15h-2v-6h-6v-2a.5.5 0 0 0-.15-.35.5.5 0 0 0-.7 0 .5.5 0 0 0-.15.35v2H5v2.2q1.36.5 2.17 1.67.83 1.18.83 2.63 0 1.42-.82 2.6A4.7 4.7 0 0 1 5 17.23z" />
  </svg>
)
export default SvgPuzzle
